export default __webpack_public_path__ + "static/media/columns-solid.c4284faa.svg";